import {Person} from '../../person';

export class PersonRetirement {
  person: Person;
  retirementDate: string;
  expectedMoney: number;
  gapPercent: number;
  value: number;
}
